import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import endPoint from "../EndPoint/endpoint";

export const ProductById = createAsyncThunk(
  "productById/ProductById",
  async (productId, thunkAPI) => {
    try {
      const response = await axios.get(
        `${endPoint.ProductSerchById}/${productId}`
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const ProductByIdSlice = createSlice({
  name: "ProductDetailsData",
  initialState: {
    ProductDetailsData: [],
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(ProductById.fulfilled, (state, action) => {
        state.ProductDetailsData = action.payload;
      })
      .addCase(ProductById.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default ProductByIdSlice.reducer;
